<template>
  <div class="loader" v-if="displayPreLoader"></div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "PreLoader",
  computed: {
    ...mapGetters("application", { displayPreLoader: "displayPreLoader" })
  }
};
</script>
<style scoped>
.loader {
  cursor: progress;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: url("../assets/img/preloader.gif") 50% 50% no-repeat
    rgb(249, 249, 249);
  opacity: 0.8;
}
</style>
